module.exports = __webpack_public_path__ + "img/template-desktop-mobile.f524da66.svg";